<template>
  <div>
    <div>
      <div class="topBpx">
        <div class="selectBox" v-if="currentSelectNode==='countBar'">
          <DatePicker v-model="currentMonth" type="month" size="small" style="margin-top: 1vh;margin-right: 1rem"
                      placeholder="选择时间" @on-change="getStatisticsBarData" :clearable="false"
          ></DatePicker>
        </div>
        <div class="tabsBtn">
          <Row :gutter="10">
            <Col :span="12">
              <p style="text-align: right" class="btnP" @click="currentSelect('timeLine')"
                 :style="{color: currentSelectNode==='timeLine'?'#BCCBEF':'#fff',fontWeight:currentSelectNode==='timeLine'?'600':'500'}">
                按时间</p>
            </Col>
            <Col :span="12">
              <p style="text-align: left" class="btnP" @click="currentSelect('countBar')"
                 :style="{color: currentSelectNode==='countBar'?'#BCCBEF':'#fff',fontWeight:currentSelectNode==='countBar'?'600':'500'}">
                按区县</p>
            </Col>
          </Row>
        </div>
      </div>
      <div id="timeLine" key="timeLine" v-show="currentSelectNode==='timeLine'" style="height: 25vh;width: 100%"></div>
      <div id="countBar" key="countBar" v-show="currentSelectNode==='countBar'" style="height: 25vh;width: 100%"></div>
    </div>

  </div>
</template>

<script>
import * as echarts from "echarts";
import { countOptions, timeOptions } from './options'

export default {
  name: "statisticsLine",
  data() {
    return {
      currentMonth: this.$moment(new Date()).format('YYYY-MM'),
      statisticsLineDom: null,
      statisticsBarDom: null,
      options: {},
      currentSelectNode: 'timeLine',
      countOptions,
      timeOptions,
      countyTime: null,
      lineTime: null,
      intervalTime: 0
    }
  },
  mounted() {
    this.getStatisticsLineData()
    this.getStatisticsBarData()
  },
  methods: {
    currentSelect(value) {
      this.$nextTick(() => {
        this.currentSelectNode = value
      })
    },
    initStatisticsCount() {
      document.getElementById("countBar").style.display = "block";
      document.getElementById("countBar").style.width = "100%";
      this.statisticsBarDom = echarts.init(document.getElementById('countBar'));
      this.statisticsBarDom.setOption(this.countOptions);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.statisticsBarDom.resize();
        });
      });
    },
    initStatisticsTime() {
      document.getElementById("timeLine").style.display = "block";
      document.getElementById("timeLine").style.width = "100%";
      this.statisticsLineDom = echarts.init(document.getElementById('timeLine'));
      this.statisticsLineDom.setOption(this.timeOptions);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          this.statisticsLineDom.resize();
        });
      });
    },
    chartMoveX(data, option, time, dom) {
      this.intervalTime = 2000
      time = setInterval(() => {
        if (data.length <= 5) {
          clearInterval(time)
          return
        }
        if (option.dataZoom[0].endValue >= data.length) {
          option.dataZoom[0].endValue = 5
          option.dataZoom[0].startValue = 0
        } else {
          option.dataZoom[0].endValue = option.dataZoom[0].endValue + 1
          option.dataZoom[0].startValue = option.dataZoom[0].startValue + 1
        }
        dom.setOption(option)
      }, this.intervalTime)
      return time
    },
    chartMoveX1(data, option, time, dom) {
      time = setInterval(() => {
        if (data.length <= 5) {
          clearInterval(time)
          return
        }
        if (option.dataZoom[0].endValue >= data.length) {
          option.dataZoom[0].endValue = 5
          option.dataZoom[0].startValue = 0
        } else {
          option.dataZoom[0].endValue = option.dataZoom[0].endValue + 1
          option.dataZoom[0].startValue = option.dataZoom[0].startValue + 1
        }
        dom.setOption(option)
      }, 2000)
      return time
    },
    getStatisticsLineData() {
      this.$http.get(`/api/getMonthEventNumber?channel=2`).then(res => {
          if (res) {
            let data = res.data
            for (let i in data) {
              this.timeOptions.xAxis[0].data.push(data[i].month)
              this.timeOptions.series[0].data.push(data[i].all)
              this.timeOptions.series[1].data.push(data[i].handled)
              this.timeOptions.series[2].data.push(data[i].handling)
            }
            this.$nextTick(() => {
              this.initStatisticsTime()
              this.chartMoveX1(data, this.timeOptions, this.lineTime, this.statisticsLineDom)
            })
          }
        }
      )
    },
    getStatisticsBarData() {
      if (this.countyTime) {
        clearInterval(this.countyTime)
      }
      this.intervalTime = 0
      this.countOptions.series[0].data = []
      this.countOptions.series[1].data = []
      this.countOptions.series[2].data = []
      this.$http.get(`/api/getCountyEventNumber?channel=2&yearAndMonth=${ this.$moment(this.currentMonth).format('yyyy-MM') }`).then(res => {
          if (res) {
            let data = res.data
            for (let i in data) {
              this.countOptions.xAxis[0].data.push(data[i].county)
              this.countOptions.series[0].data.push(parseInt(data[i].all))
              this.countOptions.series[1].data.push(parseInt(data[i].handled))
              this.countOptions.series[2].data.push(parseInt(data[i].handling))
            }

            this.$nextTick(() => {
              this.initStatisticsCount()
              this.countyTime = this.chartMoveX(data, this.countOptions, this.countyTime, this.statisticsBarDom)
            })
          }
        }
      )
    }
  }
}
</script>

<style scoped lang="less">
@import "statusticLine.less";

#countBar {
  width: 100%;
  height: 25vh;
}

#timeLine {
  width: 100%;
  height: 25vh;
}

.topBpx {
  width: 100%;
  height: 4vh;

  .selectBox {
    width: 6rem;
    height: 4vh;
    float: right;
  }

  .tabsBtn {
    height: 1.5rem;
    width: 7rem;
    margin: 0 auto;
    transform: translateX(-2rem);
    background-image: url("../../../../images/tabsBtn.png");
    background-size: 100% 100%;

    p {
      font-size: .6rem;
      color: #fff;
      line-height: 2rem;
      cursor: pointer;
    }
  }
}
</style>
